import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';   
import { getCircular } from "../Service/Api"; 
const Datesheet = () => {  
  useEffect(() => {
    document.title = 'Datesheet - St. Francis Xavier School';  
}, []); 
const [data, setData] = useState([]);
const [filterData, setFilteredData] = useState([]);
const [selectedYear, setSelectedYear] = useState("All");
const [selectedMonth, setSelectedMonth] = useState("All");
const [yearRanges, setYearRanges] = useState([]);
const [availableMonths, setAvailableMonths] = useState([]);
const [searchQuery, setSearchQuery] = useState("");
const monthsOfYear = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const handleMonth = (month) => {
    return monthsOfYear[month - 1];
};

useEffect(() => {
    const fetchData = async () => {
        try {
            const galleryData1 = await getCircular();
             const galleryData = galleryData1.filter((item) => item.category ==="Datesheet");
            setData(galleryData);

            const uniqueYears = Array.from(
                new Set(galleryData.map(item => item.date ? new Date(item.date).getFullYear() : null))
            ).filter(year => year != null).sort((a, b) => b - a);

            setYearRanges(uniqueYears);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    fetchData();
}, []);

useEffect(() => {
    console.log("Current data state:", data); // Debugging log
    let filteredData = data;
    let monthsSet = new Set();

    if (selectedYear !== "All") {
        filteredData = data.filter(item => {
            if (item.date) {
                const year = new Date(item.date).getFullYear();
                if (parseInt(selectedYear) === year) {
                    const month = new Date(item.date).getMonth() + 1;
                    monthsSet.add(month);
                    return true;
                }
            }
            return false;
        });
    }

    if (selectedMonth !== "All") {
        filteredData = filteredData.filter(item => {
            const month = item.date ? new Date(item.date).getMonth() + 1 : null;
            return month === parseInt(selectedMonth);
        });
    }

    if (searchQuery) {
        filteredData = filteredData.filter(item =>
            item.title.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }

    setAvailableMonths([...monthsSet].sort((a, b) => a - b));
    setFilteredData(filteredData);
    console.log("Filtered data:", filteredData); // Debugging log
}, [selectedYear, selectedMonth, searchQuery, data]);

const emptyArray = [
    { title: "Datesheet Title" },
    { title: "Datesheet Title" },
];
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>School</li>
                    <li>Datesheet</li>
                </ul>
            </div> 
            <section className="innerbody">
                <div className="container"> 
                <div className="row"> 
                <div className="col-md-12">
                <div className="chooseyear">
                <select id="yearSelection"
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                        className="yearSelection"
                    >
                        <option value={"All"}>All</option>
                        {yearRanges.map((yr) => (
                            <option key={yr} value={yr}>{yr}</option>
                        ))}
                    </select> 
                  </div>  
                </div>
            </div>
            <div className="clr"></div>
                <div className="row">  
                    {filterData.length > 0 && filterData.map((item, index) => (
                            <div className="col-lg-4" key={index}> 
                            <Link to={`https://webapi.entab.info/api/image/${item?.attachments[0]}`} target="_blank">
                                <div className="sample-blk">
                                  <div>
                                       <p> {item.title}</p>
                                      <span>{item.date}</span>
                                  </div> 
                                  <img alt="SFXH" src="https://webapi.entab.info/api/image/SFXH/public/images/pdf.png" className="img-fluid"/> </div> 
                               </Link>
                        </div>
                        ))}
                </div>
            </div> 
           </section>
           <Footer/>
        </>
    );
}

export default Datesheet;
